// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 222) return "static/chunks/vendors.sravni-76d8c5e50be3d619.js";
	if (chunkId === 893) return "static/chunks/893-58ed2ecf7c5664f3.js";
	if (chunkId === 300) return "static/chunks/300-24a8e4da868976f7.js";
	if (chunkId === 928) return "static/chunks/928-28c81f9168c4c0f1.js";
	if (chunkId === 637) return "static/chunks/637-ee434ee5267b1602.js";
	if (chunkId === 832) return "static/chunks/832-0f0eb967b827527e.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"296":"ea88be26","987":"react-lottie"}[chunkId] || chunkId) + "." + {"203":"f6474b468c85406a","296":"708e47fd560a6f87","458":"d7537843da7db6af","548":"124e9fbb6c3daf70","562":"ec6e2ace869d3930","606":"d0c4f146d36fcccc","987":"932b9eecaffb4c28"}[chunkId] + ".js";
};